import React from "react";
import { Image } from "react-bootstrap";
import {FaComment, FaCalendar, FaUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import rightarrow from '../../../assets/img/arrowRight.svg'

const ArticlesCard = ({ article }) => {

  return (
    <div className="artical_cards h-100" style={{background:'#faf7f3'}}>
      <div className="image-box">
        <figure className="image">
          <Link to={`/article/${article.id}`} style={{ cursor: "pointer" }}>
            <Image src={article?.full_image_path} alt={article.caption} className="w-100" />
          </Link>
        </figure>
      </div>

      <div className="lower-content" >
        <ul className="artical-info">
          <li>
            <FaUser className="me-1" style={{ color: "#f9d600" }} />
            <Link to={`/article/author/${article?.caption?.toLowerCase() ?? ""}`}>
              {article.post_user_detail?.name}
            </Link>
          </li>
        </ul>

        <h3>
          <Link to={`/article/${article.id}`} style={{ cursor: "pointer" }}>
            {article.caption}
          </Link>
        </h3>

        <div className="artical-info justify-content-center">
          <Link
            to={`${article.link}#comment-wrapper-section`}
            style={{ color: "#9C9C9C" }}
          >
            <FaComment className="me-1" style={{ color: "#f9d600" }} />{" "}
            {article.comments_count} Comments
          </Link>
          <span style={{ color: "#9C9C9C" }}>
            <FaCalendar className="me-1" style={{ color: "#f9d600" }} />{" "}
            {article.date}
          </span>
        </div>
      </div>
        <div className="link">
          <a href={`/article/${article.id}`} style={{ cursor: "pointer" }}>
          <img src={rightarrow} alt="" />
          </a>
        </div>
      </div>
  );
};

export default ArticlesCard;